module.exports = __webpack_public_path__ + "static/img/pcTitle2.40ae8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcTitle2.png
// module id = Y81x
// module chunks = 1